import React from 'react';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import LandingMediaKitProposal from '../TNOMediaKitProposal';

const tnoBusinessPatrocinioTheme = createMuiTheme({
  palette: {
    primary: {
      main: '#00695c',
      light: '#00897b',
      dark: '#004d40',
    },
  },
});

const LandingMediaKitTNOBusinessPatrocinio = (props) => (
  <ThemeProvider theme={tnoBusinessPatrocinioTheme}>
    <LandingMediaKitProposal {...props} staticOnly forcedSlug="patrocinio-tno-business" />
  </ThemeProvider>
);

export default LandingMediaKitTNOBusinessPatrocinio;
